import React from "react";
import Errorgif from "./assets/error.gif";
import style from "./Error.module.css";

const Error = () => {
  return (
    <div>
      <div className={style.ErrorPage}>
        <img src={Errorgif} />
        <div className={style.errorname}>Please Check Configration</div>
      </div>
    </div>
  );
};

export default Error;
